export const HIDE_ADVISORY_SUITE_BANNER_KEY = 'vdr-hide-advisory-suite-banner';
export const HIDE_ADVISORY_SUITE_NOTIFICATION_KEY = 'vdr-hide-advisory-suite-notification';
